import React from "react";
import "../styles/OfficerCard.css"; // Create this file for styling

const OfficerCard = ({ image, name, position }) => {
  return (
    <div className="officer-card">
      <img src={image} alt={name} className="officer-img" />
      <h3>{name}</h3>
      <p>{position}</p>
    </div>
  );
};

export default OfficerCard;
